module.exports = __webpack_public_path__ + "img/08.aa9dbfbb.jpg";